var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 2.1665C7.03018 2.1665 2.16602 7.03067 2.16602 12.9998C2.16602 18.969 7.03018 23.8332 12.9993 23.8332C18.9685 23.8332 23.8327 18.969 23.8327 12.9998C23.8327 7.03067 18.9685 2.1665 12.9993 2.1665ZM17.7119 16.8673C17.5602 17.1273 17.2893 17.2682 17.0077 17.2682C16.8668 17.2682 16.726 17.2357 16.596 17.149L13.2377 15.1448C12.4035 14.6465 11.786 13.5523 11.786 12.5882V8.1465C11.786 7.70234 12.1543 7.334 12.5985 7.334C13.0427 7.334 13.411 7.70234 13.411 8.1465V12.5882C13.411 12.9782 13.736 13.5523 14.0718 13.7473L17.4302 15.7515C17.8202 15.979 17.9502 16.4773 17.7119 16.8673Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.214dc71a309e97ceb878d0670e812ccb.svg";
export { ForwardRef as ReactComponent };